import DefaultCRUD from '../utils'
const resource = `/torcevoe-ograzdenie`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
